import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { INTERACTABLE_TILE_SWATCHES_XP_250528 } from "@faire/web-api--source/indigofair/settings/INTERACTABLE_TILE_SWATCHES_XP_250528";

export const useSettingInteractableTileSwatches = (): boolean =>
  useSetting(INTERACTABLE_TILE_SWATCHES_XP_250528, false);
